import { spawn } from 'redux-saga/effects';

import { sagas as detailsSagas } from './detailsModule';

export default function* sagas() {
	yield spawn(detailsSagas);
}
